import { Organization, WorkspaceResult as Workspace } from '@/api/';
import { atom } from 'nanostores';

export const $orgnizationSelected = atom<boolean | undefined>();
export const $workspaceSelected = atom<boolean | undefined>();

/**
 * The current organization for the user, if present within the settings.
 */
export const $orgInSettings = atom<Organization | undefined>();

/**
 * The current selected workspace within the settings
 */
export const $workspaceInSettings = atom<Workspace | undefined>();
